import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link  from '../utils/link'
import { RightArrow } from './icons'

const Digital = ({title, video, image, client, sector, technology, services, free, weblink}) => {
  return (
    <section className='digital'>
      <div className='digital__inner'>
        { title && <h2>{parse(title)}</h2> }
        <div className='digital__wrapper'>
          <div className='digital__media'>
            { video && <video src={video} autoPlay loop muted playsInline /> }
            { image && !video && <GatsbyImage image={getImage(image.localFile)} alt={title} /> }
          </div>
          <div className='digital__content'>
            { client && <h3>{parse(client)}</h3> }
            { sector && <span className='digital__sector'>{parse(sector)}</span> }
            <div className='digital__copy-wrap'>
              <div className='digital__copy'>
                <h4>Technology</h4>
                { technology && <p>{parse(technology)}</p> }
              </div>
              <div className='digital__copy'>
                <h4>Services</h4>
                { services && <p>{parse(services)}</p> }
              </div>
              { free && free.title && free.content &&
                <div className='digital__copy'>
                  <h4>{free.title}</h4>
                  { free.content && <p>{parse(free.content)}</p> }
                </div>
              }
            </div>
            { weblink && <Link className='button' to={weblink}><span>{weblink.replace(/^https?:\/\//, '').replace(/\/$/, '')}</span> <RightArrow /></Link>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Digital